<div class="w--100 h--100 container-reload">
    <svg-icon title="Hunch"
    name="HunchIcon" alt="" svgClass="table-icon hunch-icon-watermark"  class="draft-icon"
    ></svg-icon>
</div>